import { AxiosResponse } from "axios";
import { toast } from "react-hot-toast";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import { createPlanFailure, createPlanSuccess } from "../slices/features/planById";
import { RequestTypes } from "../types";

const createPlanService = new AppService();

function* createPlanSaga(action: any) {
  const { payload } = action;
  const { data } = payload;

  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      createPlanService.createPlanRequest,
      baseUrl,
      data
    );

    toast.success("Company create successfully!");

    payload?.cbSuccess && payload?.cbSuccess();
    yield put(createPlanSuccess({ ...response }));
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const {
      data: {
        errors: { message },
      },
    } = error;

    toast.error(Array.isArray(message) ? message[0] : message);

    payload?.cbFailure && payload?.cbFailure(message);
    yield put(createPlanFailure({ statusCode, statusText }));
  }
}

export function* watchCreatePlan() {
  yield takeLatest(RequestTypes.CREATE_PLAN_REQUEST, createPlanSaga);
}
